import React from 'react';
import { VerificationLoader } from '../verification';
import { PageLayout } from '../layout';

interface SuspenseLoaderProps {
  docId?: string | null;
}

const SuspenseLoader: React.FC<SuspenseLoaderProps> = ({ docId: _docId }) => {
  const isMobile = window.innerWidth < 768;

  // In unit tests some modules are mocked; provide a minimal fallback if VerificationLoader is undefined
  const LoaderComponent = VerificationLoader;
  const content = LoaderComponent ? (
    <LoaderComponent
      isVisible={true}
      isMobile={isMobile}
      mode="loading"
      overlay={false}
    />
  ) : (
    <output className="text-gray-500 text-sm">Loading…</output>
  );

  return (
    <PageLayout showHeader={false}>
      <div className="flex flex-col items-center justify-center min-h-screen">
        {content}
      </div>
    </PageLayout>
  );
};

export default SuspenseLoader;
